const PAYMENT_STATUS_TITLES = {
  unpaid: 'Chờ thanh toán',
  partial: 'Thanh toán 1 phần',
  paid: 'Đã thanh toán',
  waiting_verification: 'Chờ xác nhận thanh toán',
};

const SHIPPING_STATUS_TITLES = {
  not_shipped: 'Chưa vận chuyển',
  shipping: 'Đang vận chuyển',
  shipped: 'Đã giao',
};

const formatStatus = (statusMap, value) => {
  if (!value) {
    return '-';
  }
  return statusMap[value] || value;
};

const getLineItemName = (item = {}) => {
  const productName = item?.product?.name || item?.product_name || item?.name || '';
  const variantTitle = item?.variant?.variant_title || item?.variant_title || '';
  const fallback = item?.product_id || 'Sản phẩm';
  const name = `${productName} ${variantTitle}`.trim();
  return name || fallback;
};

const useOrderSnapshotModal = ({ snapshot }) => {
  const customerName = snapshot?.customer?.full_name || snapshot?.shipping_address?.full_name || '-';
  const customerPhone = snapshot?.customer?.phone || snapshot?.shipping_address?.phone_number || '-';
  const paymentTitle = formatStatus(PAYMENT_STATUS_TITLES, snapshot?.payment_status?.id);
  const shippingTitle = formatStatus(SHIPPING_STATUS_TITLES, snapshot?.shipping_status?.id);

  return {
    snapshot,
    customerName,
    customerPhone,
    paymentTitle,
    shippingTitle,
    getLineItemName,
  };
};

export default useOrderSnapshotModal;